export default "__VITE_ASSET__mbmXZ6mI__"